import { UserType } from "core/features/auth/typings/auth";
import { PerfisEnum } from "core/features/users/enums";
import { TalhaoJustificados } from "../../interfaces/Talhao";

export const PAGES_QTDE = [
    {
        label: "10 / páginas",
        value: 10
    },
    {
        label: "20 / páginas",
        value: 20
    },
    {
        label: "50 / páginas",
        value: 50
    },
    {
        label: "100 / páginas",
        value: 100
    },
];

export function groupData<T extends Record<string, any>>(
  data: T[] | undefined,
  field: any
) {
  if (!data) return [];
  const groups: Record<string, T[]> = {};

  data.forEach(item => {
    const key = item[field] ?? 'Outros';
    if (!groups[key]) groups[key] = [];
    groups[key].push(item);
  });

  const result: any[] = [];

  Object.entries(groups)
    .sort(([a], [b]) => a.localeCompare(b))
    .forEach(([key, items]) => {
      result.push({
        type: 'group',
        key: `group-${key}`,
        label: key,
        count: items.length,
      });

      items
        .sort((a, b) =>
          String(a[field]).localeCompare(String(b[field]))
        )
        .forEach(item =>
          result.push({
            ...item,
            type: 'row',
            key: item.planoOperacionalOperacaoTalhaoId,
          })
        );
    });

  return result;
}

export function setStatusArr(talhaoJustificativa: TalhaoJustificados, user: Partial<UserType> | null, statusStr: string) {
    const gerenteUnidade = talhaoJustificativa?.justificativaAtrasoAceiteGerenteUnidadeUsuario;
    const gerenteRegional = talhaoJustificativa?.justificativaAtrasoAceiteGerenteRegionalUsuario;
    
    let status = "";

    if (gerenteUnidade && gerenteRegional) {
        status = "Aprovado N2";
    } else if (gerenteUnidade) {
        status = statusStr;
    } else {
        status = "Pendente N1";
    }

    return status;
}

export function setBlocked(status: string | undefined, user: Partial<UserType> | null) {
    if (!status) return undefined;
    const perfis = user?.perfis;
    
    const hasGerenteUnidadePermission = perfis?.some((i) => i?.includes(PerfisEnum.Gerente_Unidade) || i?.includes('Agenda de Campo -Gerente de Unidade'));
    const hasGerenteRegionalPermission = perfis?.some((i) => i === PerfisEnum.Gerente_Regional);
    const hasAdmPermission = perfis?.some((i) => i === PerfisEnum.Administrador);
    if (status === "Pendente N1" && (hasGerenteUnidadePermission || hasAdmPermission)) {
        return false;
    } else if (status === "Pendente N2" && (hasGerenteRegionalPermission || hasAdmPermission)) {
        return false;
    } else if (status === "Aprovado N1"  && (hasGerenteRegionalPermission || hasAdmPermission)) {
        return false;
    } else if (status === "Aprovado N2") {
        return true;
    }

    return true;
}